<template>
  <div
    :class="[
      'w-full sticky top-0 left-0 -ml-4 right-0 flex justify-between z-30',
      sizeClass,
      'bg-gradient-to-r from-[#7C3AED] to-[#A78BFA] px-10 py-5',
    ]"
  >
    <div class="inline-flex items-center">
      <div :class="iconPaddingClass">
        <AM3Icon
          type="lock-closed"
          color="white"
          size="xl"
        />
      </div>
      <div>
        <h2 class="text-white font-bold text-lg mb-2">
          {{ title }}
        </h2>
        <p
          class="text-xs text-white whitespace-pre-line"
          v-html="subtitle"
        />
      </div>
    </div>

    <div
      v-if="buttonText"
      class="inline-flex items-center pl-3"
    >
      <AM3Button
        :text="buttonText"
        type="secondary"
        :icon-left="buttonIconLeft"
        @click="handlePlanClick"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AM3Button from '@/components/am3-generic/base/AM3Button.vue'

const emit = defineEmits(['click'])

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  subtitle: {
    type: String,
    default: null,
  },
  buttonText: {
    type: String,
    default: 'Upgrade Plan',
  },
  buttonIconLeft: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    default: 'medium',
    validator: (val: string) => ['small', 'medium'].includes(val),
  },
})

const handlePlanClick = (e: Event) => {
  emit('click', e)
}

const sizeClass = computed(() => {
  return props.size === 'small' ? 'p-2.5' : 'py-5 px-10'
})

const iconPaddingClass = computed(() => {
  return props.size === 'small' ? 'pr-3' : 'pr-7'
})
</script>
